module.exports = __webpack_public_path__ + "img/Mastercard-logo.8bbb5517.png";